import { useState } from 'react';

import ArrowLink, { type ArrowLinkVariant } from 'components/ArrowLink';
import { PartialPopover } from 'components/Popover';

import type { ValidPopoverLink, ValidSitecoreLink } from './helpers';

interface Props {
	className?: string;
	link: ValidSitecoreLink;
	variant?: ArrowLinkVariant;
}

function WithPopover({
	className,
	link,
	variant,
}: Props & { link: ValidPopoverLink }) {
	const [isOpen, setIsOpen] = useState(false);

	return (
		<>
			<ArrowLink
				className={className}
				text={link.text}
				onClick={() => setIsOpen(true)}
				aria-haspopup="dialog"
				variant={variant}
			/>
			<PartialPopover
				isOpen={isOpen}
				partial={link.href}
				heading={link.title}
				onClose={() => setIsOpen(false)}
			/>
		</>
	);
}
WithPopover.displayName = 'ScArrowLink_WithPopover';

export default function ScArrowLink({ className, link, variant }: Props) {
	if (link.linktype === 'popover') {
		return <WithPopover className={className} link={link} />;
	}
	return (
		<ArrowLink
			className={className}
			href={link.href}
			text={link.text}
			target={link.target}
			variant={variant}
		/>
	);
}
ScArrowLink.displayName = 'ScArrowLink';
